import { render, staticRenderFns } from "./ProdutosMaisVendidos.vue?vue&type=template&id=567b7d36&"
import script from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"
export * from "./ProdutosMaisVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567b7d36')) {
      api.createRecord('567b7d36', component.options)
    } else {
      api.reload('567b7d36', component.options)
    }
    module.hot.accept("./ProdutosMaisVendidos.vue?vue&type=template&id=567b7d36&", function () {
      api.rerender('567b7d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProdutosMaisVendidos.vue"
export default component.exports